import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { api } from 'api';
import { notify } from 'libs/common';
import { Button, themes } from 'libs/ui';
import { ToggleBox, Toggle, ToggleWrap, Buttons, Content, Zone, /*ZoneIcon,*/ ZoneInput, ZoneTitle } from './zones-lk.styled';

export const ZonesLK = (props) => {
  const { t } = useTranslation();

  const { clientId } = props;
  const [ready, setReady] = useState(false);
  const [limits, setLimits] = useState([]);
  const [orders, setOrders] = useState(true);
  const [validation, setValidation] = useState(true);
  const [excemption, setExcemption] = useState(true);
  const [old, setOld] = useState(false);

  useEffect(() => {
    const getData = () => {
      api.call('clients.get_zones', { client_id: clientId }).then((data) => {
        //console.log('🚀 ~ api ~ data', data);
        // const colors = zones.getZonesColors();
        if (data.zones !== undefined) {
          const limits = data.zones.map((el) => {
            const elOk = { ...el };
            if (!el.id) {
              el.id = el.zone_id;
              el.name = el.zone_id;
            }
            return { ...elOk /*color: colors[el.zone_id]*/ };
          });
          setLimits(limits);
          setOrders(data.orders);
          setValidation(data.validation);
          setExcemption(data.excemption);
        } else {
          const limits = data.map((el) => {
            return { ...el /*color: colors[el.zone_id]*/ };
          });

          setLimits(limits);
          setOld(true);
        }

        setReady(true);
      });
    };
    getData();
  }, []);

  /**
   * change value
   * @param {*} idx
   */
  const change = (idx) => {
    const out = limits.splice(0);
    let val = out[idx].is_zone_visible;
    out[idx].is_zone_visible = !val;
    setLimits(out);
  };

  /**
   * get zone inputs
   * @returns
   */
  const getZonesEl = () => {
    return limits.map((el, idx) => {
      return (
        <Zone key={idx}>
          {/* <ZoneIcon color={el.color} /> */}
          <ZoneTitle>{el.name}</ZoneTitle>
          <ZoneInput>
            <ToggleBox isActive={el.is_zone_visible}>
              {/* <p>{t('grid.Нет')}</p> */}
              <Toggle isActive={el.is_zone_visible} onClick={() => change(idx)}>
                <div></div>
              </Toggle>
              {/* <p>{t('grid.Доступна')}</p> */}
            </ToggleBox>
          </ZoneInput>
        </Zone>
      );
    });
  };

  /**
   * save
   */
  const save = () => {
    const out = limits.map((el) => {
      return { id: el.id, is_zone_visible: el.is_zone_visible };
    });
    //console.log('🚀 ~ out', out);
    api.call('clients.set_zones', { client_id: clientId, zones: out, orders, validation, excemption }).then((data) => {
      notify('Категории ЛК', 'Категории ЛК сохранены', 'success');
    });
  };

  /**
   * set checkbox value
   * @param {*} event
   */
  const setCBValue = (event) => {
    const name = event.target.name;
    const checked = event.target.checked;
    // console.log('🚀 ~ setCBValue ~ ', checked);
    switch (name) {
      case 'excemption':
        setExcemption(!checked);
        break;
      case 'orders':
        setOrders(!checked);
        break;
      default:
      case 'validation':
        setValidation(!checked);
        break;
    }
  };

  if (!ready) {
    return null;
  }

  const zonesEl = getZonesEl();

  return (
    <Content>
      {!old && (
        <>
          <ToggleWrap>
            <label htmlFor="validationInput">{t('clients.Валидация')}</label>
            <Toggle isActive={validation} onClick={() => setCBValue({ target: { name: 'validation', checked: validation } })}>
              <div></div>
            </Toggle>

            <label htmlFor="orderInput">{t('clients.Заявки')}</label>
            <Toggle isActive={orders} onClick={() => setCBValue({ target: { name: 'orders', checked: orders } })}>
              <div></div>
            </Toggle>

            <label htmlFor="orderInput">{t('clients.Свободный проезд')}</label>
            <Toggle isActive={excemption} onClick={() => setCBValue({ target: { name: 'excemption', checked: excemption } })}>
              <div></div>
            </Toggle>

            {/* <Checkboxes>
            <Checkbox className="checkbox">
            <input id="validationInput" onChange={setCBValue} type="checkbox" name="validation" checked={validation} />
            <label htmlFor="validationInput">{t('grid.Валидация')}</label>
            </Checkbox>
            <Checkbox className="checkbox">
            <input id="orderInput" onChange={setCBValue} type="checkbox" name="orders" checked={orders} />
            <label htmlFor="orderInput">{t('grid.Заявки')}</label>
            </Checkbox>
            </Checkboxes> */}
          </ToggleWrap>
        </>
      )}
      {zonesEl}
      <Buttons>
        <Button theme={themes.gray} onClick={save}>
          <i className="fa fa-save" />
          {t('buttons.Сохранить')}
        </Button>
      </Buttons>
    </Content>
  );
};
